var version = {
    "name":      "dativery",
    "buildDateCode": "20260619-094910",
    "buildDate": "Fri Jun 19 2026 09:49:10 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260619-094910",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;